import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeDpiLocaleModule: LocaleModule = {
  name: "employeeDpi",
  messages: { en: en, it: it },
};
